import { AnchorLink, AnchorLinkType } from '../anchorLink';
import { Icon, toIconsEnum } from '../Icons';
import { selectSaldoPrelevabile, selectWalletFetchStatus } from 'features/dashboard/selectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useEffect } from 'react';

import { Button } from 'components/button/Button';
import { Wrapper } from 'components/wrapper';
import { getWallet } from 'features/dashboard/action';
import { setIsOpenLoginModalValue } from 'features/modal/modalSlice';
import styles from './NeedHelp.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useInternalSession } from 'hooks/useInternalSession';
import { useWebchatLogin } from 'hooks/useWebchat';

export type Option = {
  id: string;
  label: string;
  link: AnchorLinkType[];
  icon: string;
};

export type NeedHelpProps = {
  heading: string;
  optionList?: Array<Option>;
};

export const NeedHelp = ({ optionList, heading }: NeedHelpProps) => {
  const labelChat = useGetLabelByKey('chat');
  const { isAuthenticated } = useInternalSession();
  const dispatch = useAppDispatch();

  const saldoPrelevabile = useTypedSelector(selectSaldoPrelevabile);
  const { isWalletUninitialized } = useTypedSelector(selectWalletFetchStatus);

  useEffect(() => {
    if (isAuthenticated && (isWalletUninitialized || !saldoPrelevabile)) {
      dispatch(getWallet({ ts: new Date() }));
    }
  }, [isAuthenticated, isWalletUninitialized, saldoPrelevabile, dispatch]);

  const { onOpen } = useWebchatLogin();

  return (
    <Wrapper noPaddingRight={true} noPaddingBottom={true} bgColorTransparent={true} noPaddingTop noPaddingLeft>
      <div className={styles.container}>
        <h3 className={styles.title}>{heading}</h3>
        <ul className={styles.links}>
          {optionList?.map((option) => {
            return (
              <li key={option.link[0].id} className={styles.link}>
                <div className={styles.iconContainer}>
                  <Icon iconId={toIconsEnum(option.icon)} className={styles.icon} color="var(--color-bg)"></Icon>
                </div>
                {option.icon === labelChat && !isAuthenticated ? (
                  <button type="button" onClick={() => dispatch(setIsOpenLoginModalValue(true))}>
                    {option.label}
                  </button>
                ) : option.link[0].href === '/chat' ? (
                  <Button onClick={onOpen}>{option.label}</Button>
                ) : (
                  <AnchorLink href={option.link[0].href!} className={styles.link}>
                    {option.label}
                  </AnchorLink>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </Wrapper>
  );
};
